import LoadingSkeleton from "components/ui/Skeleton";

const ShelfSkeleton = () => {
  return <LoadingSkeleton className="w-20 h-32 rounded-md shrink m-2" />;
};

export default function ShelfCollectionSkeleton() {
  return (
    <div className="mt-4 grid grid-cols-4 lg:grid-cols-8 gap-2">
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
      <ShelfSkeleton />
    </div>
  );
}
